<template>
  <history-card-layout
    v-on="$listeners"
    v-if="context"
    @date-range="setDateFilter"
    @select-date="downloadHistory"
  >
    <popup2
      v-model="showPopup"
      width="428"
      @click:outside="handleClose"
      v-if="currentArgument"
    >
      <layout-popup>
        <template slot="header">
          {{ currentArgument.name }}
        </template>
        <template>
          <div class="px-5">
            <div
              class="pt-2 pb-2"
              v-for="item in listArguments(currentArgument.params)"
              :key="item.nodeId"
            >
              {{ item.argument }}: {{ `${item.value}` }}
            </div>
            <div
              class="pt-2 pb-2"
              v-if="!listArguments(currentArgument.params).length"
            >
              No arguments
            </div>
          </div>
          <v-divider class="mt-5" v-if="linkedReports.length" />
          <v-list v-if="linkedReports.length">
            <v-hover
              v-slot:default="{ hover }"
              :key="item.node.id"
              v-for="item in linkedReports"
            >
              <v-list-item class="px-5">
                <v-list-item-content class="pt-0">
                  <v-list-item-title class="text-wrap">
                    {{ item.node.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    {{ convertDate(item.node.createdAt) }}, error:
                    {{ item.node.error }}, done: {{ item.node.done }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-hover>
          </v-list>

          <div class="px-5 text-center" v-if="loadingReports">
            <v-divider />
            <v-progress-circular
              class="mt-2 mb-2"
              size="25"
              width="2"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
        </template>
        <template slot="footer">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            @click="copyToClipboard(JSON.stringify(currentArgument))"
            text
            >copy</v-btn
          >
          <v-btn text @click="handleClose">close</v-btn>
        </template>
      </layout-popup>
    </popup2>
    {{ getTitle() }}
    <template slot="list" v-if="typeAction === 'controls-history'">
      <v-list>
        <v-hover
          v-slot:default="{ hover }"
          v-for="item in structuredList().items"
          :key="item.createdAt"
        >
          <div>
            <div v-if="stealth()" class="pa-2 text-center text-body-2">
              "Stealth" property: no history recording
            </div>
            <v-list-item>
              <v-list-item-avatar :color="item.icon.bg" size="40">
                <v-icon :color="item.icon.color" v-if="item.icon">
                  {{ item.icon.name }}
                </v-icon>
                <span class="white--text headline" v-else-if="item.initials">
                  {{ item.initials }}
                </span>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title
                  v-if="item.title"
                  :data-history-value="item.title"
                >
                  {{ item.title }}
                </v-list-item-title>

                <v-list-item-subtitle
                  v-for="subtitle in item.subtitles"
                  :key="subtitle"
                >
                  {{ subtitle }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn
                  slot="activator"
                  @click="showArguments(item)"
                  v-show="hover || $vuetify.breakpoint.mdAndDown"
                  class="table-button-context"
                  icon
                >
                  <v-icon>mdi-information</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </div>
        </v-hover>
        <infinite-loading @infinite="loadHistoryItem">
          <div slot="spinner">
            <v-progress-circular
              class="mt-2"
              size="25"
              width="2"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          <div slot="no-more"></div>
          <div slot="no-results">
            <template v-if="!stealth()">
              No history found
            </template>
            <template v-else>
              "Stealth" property: no history recording
            </template>
          </div>
        </infinite-loading>
      </v-list>
    </template>
    <template slot="list" v-else-if="typeAction === 'show-noty-by-object'">
      <v-hover
        v-slot:default="{ hover }"
        v-for="item in buildNotifications()"
        :key="item.id"
      >
        <v-list-item @click="$router.push(`/notifications/${item.id}`)">
          <v-list-item-avatar :color="item.icon.bg" size="40">
            <v-icon :color="item.icon.color" v-if="item.icon">
              {{ item.icon.name }}
            </v-icon>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title v-if="item.title">
              {{ item.title }}
            </v-list-item-title>

            <v-list-item-subtitle
              v-for="subtitle in item.subtitles"
              :key="subtitle"
            >
              {{ subtitle }}
            </v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action></v-list-item-action>
        </v-list-item>
      </v-hover>
      <infinite-loading @infinite="loadNotification">
        <div slot="spinner">
          <v-progress-circular
            class="mt-2"
            size="25"
            width="2"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
        <div slot="no-more"></div>
        <div slot="no-results">No notifications found</div>
      </infinite-loading>
    </template>
    <template slot="list" v-else>
      <v-list>
        <v-hover
          v-slot:default="{ hover }"
          v-for="item in structuredListProperties().items"
          :key="item.recordedAt"
        >
          <div>
            <div v-if="stealth()" class="pa-2 text-center text-body-2">
              "Stealth" property: no history recording
            </div>
            <v-list-item @click="() => ({})">
              <v-list-item-content>
                <v-list-item-title
                  v-if="item.title"
                  :data-test-history-value="item.title"
                >
                  {{ item.title }}
                </v-list-item-title>

                <v-list-item-subtitle
                  v-for="subtitle in item.subtitles"
                  :key="subtitle"
                >
                  {{ subtitle }}
                </v-list-item-subtitle>
              </v-list-item-content>

              <v-list-item-action>
                <v-btn
                  slot="activator"
                  @click="copyToClipboard(JSON.stringify(item.raw.node.value))"
                  v-show="hover || $vuetify.breakpoint.mdAndDown"
                  class="table-button-context"
                  icon
                >
                  <v-icon>mdi-content-copy</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </div>
        </v-hover>
        <infinite-loading
          @infinite="loadPropertiesHistory"
          :key="infiniteRerender"
        >
          <div slot="spinner">
            <v-progress-circular
              class="mt-2"
              size="25"
              width="2"
              indeterminate
              color="primary"
            ></v-progress-circular>
          </div>
          <div slot="no-more"></div>
          <div slot="no-results">
            <template v-if="!stealth()">
              No history found
            </template>
            <template v-else>
              "Stealth" property: no history recording
            </template>
          </div>
        </infinite-loading>
      </v-list>
    </template>
  </history-card-layout>
</template>
<script>
import HistoryCardLayout from '@/components/history-card/HistoryCardLayout';
import useObjects from '@/api/objects';
import useNoty from '@/api/notifications';
import { ref, watch } from '@vue/composition-api';
import InfiniteLoading from 'vue-infinite-loading';
import copyToClipboard from '@/utils/copyToClipboard';
import downloadBlob from '@/utils/downloadBlob';
import LayoutPopup from '@/layouts/LayoutPopup';
import getIconByTags from '@/utils/getIconByTags';
import isJsonString from '@/utils/validation/isJson';
import useDownloadHistory from '@/api/objects/useDownloadHistory';
import { computeRpcStatus } from '@/utils/computeRpcStatus';

export default {
  components: {
    HistoryCardLayout,
    InfiniteLoading,
    LayoutPopup
  },
  props: {
    context: {
      type: [String, Object],
      default: ''
    },
    entity: {
      type: Object,
      default: () => ({})
    },
    typeAction: {
      type: String,
      default: 'controls'
    },
    object: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props, context) {
    const { object } = new useObjects();
    const list = ref([]);
    const listProperties = ref([]);
    const linkedReports = ref([]);
    const loadingReports = ref(true);
    const objectNotifications = ref([]);
    const perPage = ref(10);
    const currentPage = ref(0);
    const currentArgument = ref('');
    const cursorPropertiesHistoryStart = ref(null);
    const cursorPropertiesHistoryEnd = ref(null);
    const showPopup = ref(false);
    const infiniteRerender = ref(1);
    const dateFilter = ref([]);
    const { notifications } = useNoty();
    const historyComposition = useDownloadHistory();

    const getTargetId = () => {
      let id =
        context.root.$route.query?.nestedId || context.root.$route.params.id;

      if (props.context && props.context?.raw?.schemaType) {
        id = props.context.id;
      }
      return id;
    };

    watch(
      () => props.context,
      () => {
        list.value = [];
        currentPage.value = 0;
      }
    );

    const loadNotification = async $state => {
      notifications.setParams({
        orderBy: 'CREATED_AT_DESC',
        filter: {
          objectId: {
            equalTo: getTargetId()
          }
        },
        first: perPage.value,
        offset: perPage.value * currentPage.value
      });

      notifications.load(getTargetId()).then(res => {
        if (res.notificationsConnection?.edges?.length) {
          list.value = [...list.value, ...res.notificationsConnection.edges];
          currentPage.value += 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      });
    };

    const loadPropertiesHistory = $state => {
      let filter = {
        objectId: {
          equalTo: getTargetId()
        }
      };

      if (props.typeAction === 'property-history') {
        Object.assign(filter, {
          recordedAt: {
            greaterThanOrEqualTo: `${dateFilter.value[1]}T00:00:00.000000+00:00`,
            lessThanOrEqualTo: `${dateFilter.value[0]}T23:59:59.000000+00:00`
          }
        });
      }

      if (props.context?.rawItem?.property) {
        let filterName = {
          property: {
            equalTo: props.context?.rawItem?.property
          }
        };

        Object.assign(filter, filterName);
      }
      object
        .getPropertiesHistory({
          filter,
          first: perPage.value,
          offset: perPage.value * currentPage.value,
          orderBy: 'RECORDED_AT_DESC'
        })
        .then(res => {
          if (res.data.objectPropertiesHistoriesConnection.edges.length) {
            list.value = [
              ...list.value,
              ...res.data.objectPropertiesHistoriesConnection.edges
            ];
            currentPage.value += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        });
    };

    const loadHistoryItem = $state => {
      let filter = {
        type: {
          equalTo: 'RPC'
        },
        objectId: {
          equalTo: getTargetId()
        }
      };

      if (props.context?.raw?.argument) {
        let filterName = {
          name: {
            equalTo: props.context.raw.argument
          },
          linkedControlId: {
            isNull: true
          }
        };

        Object.assign(filter, filterName);
      }
      object
        .getHistoryControls({
          filter,
          first: perPage.value,
          offset: perPage.value * currentPage.value,
          orderBy: 'CREATED_AT_DESC'
        })
        .then(res => {
          if (res.data.controlExecutionsConnection.edges.length) {
            list.value = [
              ...list.value,
              ...res.data.controlExecutionsConnection.edges
            ];
            currentPage.value += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        });
    };

    const showArguments = value => {
      linkedReports.value = [];
      currentArgument.value = value.raw.node;
      showPopup.value = true;
      loadingReports.value = true;
      object
        .getReportsForControlExecution({
          objectId:
            context.root.$route.query?.nestedId ||
            context.root.$route.params.id,
          linkedControlId: value.id
        })
        .then(({ data }) => {
          linkedReports.value = data.controlExecutions.map(item => ({
            node: item
          }));
        })
        .finally(() => {
          loadingReports.value = false;
        });
    };

    const handleClose = () => {
      showPopup.value = false;
    };

    const getStatus = execution => {
      let prefilled = {
        icon: {
          name: '',
          color: '',
          bg: ''
        }
      };

      computeRpcStatus(execution, prefilled);
      return prefilled.icon;
    };

    const convertDate = date => {
      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        hour12: true,
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      }).format(new Date(date));
    };

    const listArguments = params => {
      let paramsInner = params;
      if (typeof params === 'string') {
        paramsInner = JSON.parse(params);
      }
      let paramsTransformed = [];
      let isArray = Array.isArray(paramsInner);
      if (isArray) {
        return paramsInner;
      } else {
        for (let prop in paramsInner) {
          paramsTransformed.push({
            argument: prop,
            isJson: isJsonString(paramsInner[prop]),
            value: paramsInner[prop]
          });
        }
      }
      return paramsTransformed;
    };

    const buildNotifications = () => {
      let innerList = [];
      list.value.forEach(item => {
        const preFilled = {
          raw: item.node,
          id: item.node.id,
          title: item.node.message,
          subtitles: [convertDate(item.node.createdAt)],
          isHoverAction: true,
          contextMenu: null,
          actionClickElement: null,
          icon: getIconByTags(item.node.tags),
          action: 'select'
        };

        innerList.push(preFilled);
      });

      return innerList;
    };

    const setDateFilter = e => {
      if (props.typeAction === 'property-history') {
        dateFilter.value = e;
        list.value = [];
        currentPage.value = 0;
        infiniteRerender.value = Date.now();
      }
    };
    const structuredList = () => {
      const arr = {
        items: [],
        additionalItems: []
      };

      let onlyRpc = list.value.filter(item => item.node.type === 'RPC');

      onlyRpc.forEach(item => {
        arr.items.push({
          id: item.node.id,
          raw: item,
          title: `${item.node.name}()`,
          subtitles: [
            `${convertDate(item.node.createdAt)} by ${item.node.caller.mName}`
          ],
          isHoverAction: false,
          contextMenu: [],
          actionClickElement: null,
          icon: getStatus(item.node),
          action: ''
        });
      });
      return arr;
    };

    const humanReadableFlag = nonHuman => {
      if (!props.object.data.object.schema) {
        return nonHuman;
      } else {
        const associateProperty = props.object.data.object.schema.schemaProperties.filter(
          item => item.property === nonHuman
        )[0];
        if (associateProperty && associateProperty.description) {
          return associateProperty.description;
        }
        return nonHuman;
      }
    };

    const downloadHistory = (date, modeSelection = 'day') => {
      if (props.typeAction === 'property-history') {
        if (props.context?.rawItem?.id) {
          historyComposition.downloadHistorySetOfProperties(
            {
              value: [
                {
                  id: props.context?.rawItem?.id
                }
              ]
            },
            modeSelection
          );
        } else {
          historyComposition.downloadHistory(
            {
              value: [
                {
                  id: getTargetId()
                }
              ]
            },
            modeSelection
          );
        }
      } else {
        if (props.context?.raw?.id) {
          // not implemented on media server side yet
          // historyComposition.downloadControlsHistoryOfObjects(
          //   {
          //     value: [
          //       {
          //         id: props.context?.raw?.id
          //       }
          //     ]
          //   },
          //   modeSelection
          // );
        } else {
          historyComposition.downloadControlsHistoryOfObjects(
            {
              value: [
                {
                  id: getTargetId()
                }
              ]
            },
            modeSelection
          );
        }
      }
    };

    const isObject = obj => {
      return (
        (typeof obj === 'object' && obj !== null) || typeof obj === 'function'
      );
    };

    const structuredListProperties = () => {
      const arr = {
        items: [],
        additionalItems: []
      };
      list.value.forEach(item => {
        arr.items.push({
          id: item.node.id,
          raw: item,
          title: `${humanReadableFlag(item.node.property)}: ${
            isObject(item.node.value)
              ? JSON.stringify(item.node.value)
              : item.node.value
          }`,
          subtitles: [
            `${convertDate(item.node.recordedAt)} by ${
              item.node.userByBy.mName
            }`
          ],
          isHoverAction: false,
          contextMenu: [],
          actionClickElement: null,
          icon: getStatus(item.node),
          action: ''
        });
      });
      return arr;
    };

    const getTitle = () => {
      return props.context?.title || props.entity.title;
    };
    const stealth = () => {
      return props.context?.rawItem?.spec?.stealth;
    };
    return {
      list,
      loadHistoryItem,
      loadPropertiesHistory,
      structuredList,
      structuredListProperties,
      showArguments,
      handleClose,
      showPopup,
      downloadHistory,
      listArguments,
      currentArgument,
      copyToClipboard,
      convertDate,
      loadNotification,
      buildNotifications,
      setDateFilter,
      infiniteRerender,
      linkedReports,
      getTitle,
      loadingReports,
      stealth
    };
  }
};
</script>
